import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { BsModalService } from "ngx-bootstrap/modal";
import { map, switchMap } from "rxjs/operators";
import { AdminUsersActions } from "./admin-users.actions";
import { UsersFeatureModalComponent } from "../users-feature-modal/users-feature-modal.component";
import { TopNavigationBarActions } from "../../core/state/top-navigation-bar.actions";

@Injectable()
export class AdminUsersEffects {
  constructor(
    private actions$: Actions,
    private modalService: BsModalService
  ) {}
  openFeaturesModal = createEffect(() =>
    this.actions$.pipe(
      ofType(AdminUsersActions.openFeaturesModal),
      switchMap((action: any) => {
        const modalRef = this.modalService.show(UsersFeatureModalComponent, {
          backdrop: "static",
          class: "modal-lg",
          keyboard: false, // disable esc key
        });

        return modalRef.content.onClose;
      }),
      map((result: { isConfirmed: boolean }) => {
        console.log("Admin Users Effects: closing dialog");
        return AdminUsersActions.setConfirmationOnModalClose();
      })
    )
  );
}
